import { GeoPoint, getGeoPointFromWKTPoint } from './GeoLocation'

export function latLng(point: string | null | undefined | GeoPoint): {
  lat: number
  lng: number
} {
  return typeof point === 'string' || point === null || point === undefined
    ? parseWKXGeometryPoint(point)
    : {
        lat: point.lat,
        lng: point.lng,
      }
}

function parseWKXGeometryPoint(point: string | null | undefined) {
  const { lat, lng } = getGeoPointFromWKTPoint(point)
  return {
    lat,
    lng,
  }
}

export function getPointFromStringOrDefault(
  pointStr?: string | { lat: number; lng: number },
): GeoPoint {
  const point = getPointFromString(pointStr)
  return point ? point : { lat: 0, lng: 0, isEmptyPoint: true }
}

export function getPointFromString(
  point?: string | { lat: number; lng: number },
): GeoPoint | undefined {
  if (point) {
    if (typeof point === 'string') {
      return getGeoPointFromWKTPoint(point)
    } else {
      const { lat, lng } = point
      return { lat, lng, isEmptyPoint: false }
    }
  }
  return
}

export function getWKTPoint(lat: number, lng: number): string {
  return `POINT(${lng} ${lat})`
}
